<div class="loadingState" *ngIf="displayLoading">
  <p-progressSpinner></p-progressSpinner>
</div>
<router-outlet></router-outlet>
<p-toast position="bottom-right"></p-toast>